import { useState } from "react";
import "./style.css";
import HamburgerIcon from "../../../../images/hamburger.svg";
import CloseIcon from "../../../../images/close-icon.png";
import BunkerLogo from "../../../../images/barbell_bunker_white.png";

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="hamburger-menu">
      <div className="sticky-header">
        <img
          alt="hamburger menu"
          onClick={() => setIsOpen(true)}
          className="hamburger-icon"
          src={HamburgerIcon as unknown as string}
        ></img>
      </div>

      {isOpen ? (
        <ul className="menu_box">
          <img
            alt="hamburger menu"
            onClick={() => setIsOpen(false)}
            className="close-icon"
            src={CloseIcon as unknown as string}
          ></img>
          <a href="#main">
            <img
              alt="Your Logo"
              className="bunker-logo"
              src={BunkerLogo as unknown as string}
            ></img>
          </a>
          <li>
            <a className="menu_item" href="#about">
              Rólunk
            </a>
          </li>
          <li>
            <a className="menu_item" href="#trainers">
              Edzőink
            </a>
          </li>
          <li>
            <a className="menu_item" href="#mobile-pw">
              Erőemelés
            </a>
          </li>
          <li>
            <a className="menu_item" href="#contact">
              Kapcsolat
            </a>
          </li>
        </ul>
      ) : null}
    </div>
  );
}

export default MobileMenu;
